module.exports = __webpack_public_path__ + "img/symbol_12.86e5e089.png";